/**
 * This is the twofa controller.
 * @memberOf twofa Module
 * @namespace twofa Controller
 */

/**
 * @name twofaEmailController
 * @desc Create the controller.
 * @param $scope
 * @param coreService
 * @param $log
 * @param $window
 * @param $timeout
 * @memberOf twofa Module.twofa Controller
 * @ngInject
 */
function twofaEmailController($scope, coreService, $log, $window, $timeout, $translate) {
  // Assign this controller as the view-model.
  var vm = this;
  var invalidErrorMessage = '';
  var unexpectedErrorMessage = '';
  var resendEmailTimeout = 60000;

  //properties
  vm.emailAddress = '';
  vm.code = '';
  vm.canResendEmail = false;
  vm.twoFactorAuthenticationType = '';
  vm.twoFactorAuthRegistered = false;
  vm.isRememberMeOn = false;
  vm.has_errors = false;
  vm.errorMessage = '';
  vm.rememberMe = false;

  //methods
  vm.exitEmailTwoFactorAuth = exitEmailTwoFactorAuth;
  vm.shouldDisableSubmit = shouldDisableSubmit;
  vm.resendEmail = resendEmail;
  vm.getFormActionUrl = getFormActionUrl;
  vm.isFatalError = isFatalError;
  vm.passcodeOnBlur = passcodeOnBlur;

  // Activate the controller.
  activate();

  // Activates the controller.
  function activate() {

    // Read Identity Server's data model & redirect to 2fa setup page or request for code
    var model = coreService.getIdentityModel();
    $scope.model = model;
    vm.emailAddress = model.email_address;
    vm.has_errors = model.has_errors;
    vm.errorCode = model.error_code;
    vm.twoFactorAuthenticationType = model.two_factor_auth_type;
    vm.twofactorselections =  $scope.model.two_factor_selections;
    vm.validateForm = validateForm;

    if (model.custom && model.custom.ui_locales) {
      $translate.use(model.custom.ui_locales);
    }

    if (model.data && model.data.resendLimitTimeInMinutes) {
      resendEmailTimeout = model.data.resendLimitTimeInMinutes * 60000;
    }

    if (vm.has_errors === true && model.errorMessage !== '') {
      vm.errorMessage = model.errorMessage;
    }

    if (typeof (model.twofactor_auth_registered) !== 'undefined') {
      vm.twoFactorAuthRegistered = model.twofactor_auth_registered;
    }

    if($scope.model.data !== null && $scope.model.data.isRememberMeOn !== null && 
      typeof($scope.model.data.isRememberMeOn) !== 'undefined'){
      vm.isRememberMeOn = $scope.model.data.isRememberMeOn;
    }

    if (!vm.isFatalError()) {
      $timeout(enableResendEmailButton, resendEmailTimeout);
    }
    
        //Setup translation    
		let stateCheck = setInterval(() => {
      if ($window.document.readyState === 'complete') {

        clearInterval(stateCheck);        
        $translate(['twofa.email.form.header', 'twofa.otp.form.header', 'twofa.email.form.intro_text1', 'twofa.email.form.intro_text2',
                    'twofa.email.form.code', 'twofa.email.form.done', 'twofa.otp.form.rememberme', 'twofa.email.form.resend_intro', 'twofa.email.form.resend'],
                    { emailAddress: vm.emailAddress}) 
        .then(function(data) {
            vm.data = data; 
            if(vm.has_errors)
            {
              setAriaLabelOnLoad(false, 'passCode');
            }
            else
            {
              setAriaLabelOnLoad(true, 'passCode');
            }        
            
            setFocus("passCode");   
        });
        
      }
    }, 0);
  }

  function passcodeOnBlur(e){    
    setAriaLabelOnLoad(false, 'passCode')
  }

  function setFocus(id)
  {
    var element = $window.document.getElementById(id);
    if(typeof(element) != 'undefined' && element != null)
    {
      $window.setTimeout(function(){ element.focus(); }, 0);
    }      
  }

  function setAriaLabelOnLoad(enable, id)
  {
    var element = document.getElementById(id);
    if(typeof(element) != 'undefined' && element != null)
    {
      var arialDescriptionText = vm.data['twofa.email.form.code'];
      
      if (enable)
      {
        arialDescriptionText = vm.data['twofa.email.form.header'] + '. ';  

        if(vm.twoFactorAuthRegistered){
          arialDescriptionText = vm.data['twofa.otp.form.header'] + '. ';
        }

        arialDescriptionText = arialDescriptionText
                              + vm.data['twofa.email.form.intro_text1']
                              + ' '
                              + vm.data['twofa.email.form.intro_text2'];
      }
      
      element.setAttribute('aria-label', arialDescriptionText);
    }
  }

  function enableResendEmailButton() {
    vm.canResendEmail = true;
  }

  function resendEmail() {
    if (!vm.canResendEmail) {
      return;
    }
    vm.canResendEmail = false;
    $timeout(enableResendEmailButton, resendEmailTimeout);
    if (!vm.twoFactorAuthRegistered) {
      $window.location.replace('/login/2fa/register/email/handler');
    } else {
      $window.location.replace('/login/2fa/verify/email/handler');
    }
  }

  function shouldDisableSubmit() {
    return vm.code === '';
  }

  function exitEmailTwoFactorAuth() {
    if (vm.twoFactorAuthRegistered) {
      $window.location.replace('/logout');
      return;
    }
    $window.location.replace('/login/2fa/register');
  }

  function getFormActionUrl() {
    if (vm.twoFactorAuthRegistered) {
      return '/login/2fa';
    }

    return '/login/2fa/register/email';
  }

  function isFatalError() {
    return vm.has_errors && vm.errorCode == -32;
  }

  function validateForm(e) { 
      if (vm.code === '') {
        // Do not submit
        e.preventDefault();
      }
  }

}

export default twofaEmailController;


// WEBPACK FOOTER //
// ./src/login/2fa/email/2fa.email.controller.js